module.exports = __webpack_public_path__ + "static/img/banner4.f3d30ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner4.png
// module id = ibpE
// module chunks = 12